import { createSlice } from '@reduxjs/toolkit';

const customFieldsSlice = createSlice({
  name: 'customFields',
  initialState: {
    fields: [],
    stepFields: [],
    counts: 0,
    editField: {},
    variables: [],
    customFieldUpdateSuccess: false,
  },
  reducers: {
    fetchCustomFields(state, action) {
      state.fields = action.payload;
    },
    fetchCustomFieldsVariables(state, action) {
      state.variables = action.payload;
    },
    fetchStepFields(state, action) {
      state.stepFields = action.payload;
    },
    customFieldsCount(state, action) {
      state.counts = action.payload;
    },
    editFieldsAction(state, action) {
      state.editField = action.payload;
    },
    customFieldUpdateSuccessAction(state, action) {
      state.customFieldUpdateSuccess = action.payload;
    },
  },
});

export const { fetchCustomFields,
  editFieldsAction, customFieldsCount, fetchCustomFieldsVariables, fetchStepFields,
  customFieldUpdateSuccessAction
} = customFieldsSlice.actions;

export default customFieldsSlice.reducer;